import React, { useState, useEffect } from "react";
import { HiMenuAlt3 } from "react-icons/hi";
import { RxCross2 } from "react-icons/rx";
import { MdOutlineDashboard } from "react-icons/md";
import { TbReportAnalytics } from "react-icons/tb";
import { IoHome } from "react-icons/io5";
import { FaChevronDown, FaChevronRight, FaGlobe } from "react-icons/fa";
import { Link } from "react-router-dom";
import { axInst } from "../../Components/Login/Service";
import { LuUsers } from "react-icons/lu";
import { useKeycloak } from "@react-keycloak/web";
import Swal from "sweetalert2";
import Avatar from "../../Artifacts/Home/Avatar.svg";
import ProfileCard from "../ProfileCard";
import ProfileCardModal from "../Modals/ProfileCardModal";

const Sidebar = ({ mobileOpen, setMobileOpen }) => {
  const { keycloak, initialized } = useKeycloak();

  const [menu, setMenu] = useState([
    { name: "Home", link: "/home", icon: IoHome, subMenu: [] },
  ]);

  const availableMenus = {
    "Sales & Marketing": {
      name: "Sales & Marketing",
      icon: MdOutlineDashboard,
      subMenu: [
        { name: "Live Dashboard", link: "/salesPreSales" },
        { name: "Daily Work Management", link: "/DailyWorkManagement" },
        { name: "KPI dashboard", link: "" },
      ],
    },
    "After Sales": {
      name: "After Sales",
      icon: TbReportAnalytics,
      subMenu: [
        { name: "Live Dashboard", link: "" },
        { name: "Daily Work Management", link: "" },
        { name: "KPI dashboard", link: "" },
      ],
    },
    "Customer Experience": {
      name: "Customer Experience",
      icon: LuUsers,
      subMenu: [
        { name: "Live Dashboard", link: "/service" },
        { name: "Daily Work Management", link: "" },
        { name: "KPI dashboard", link: "" },
      ],
    },
  };

  const menuOthers = [
    {
      name: "Other Apps",
      link: "/Others",
      icon: FaGlobe,
      subMenu: [],
    },
  ];
  const handleLogout = async () => {
    Swal.fire({
      title: "Your session is expired.",
      text: "",
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Login",
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          sessionStorage.clear();
          keycloak.logout({ redirectUri: window.location.origin });
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  axInst.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.data?.message === "Invalid token") {
        // windows.reload();
        handleLogout();
      }
      return Promise.reject(error);
    }
  );

  const handleOpenModal = () => {
    setIsProfileOpen(true);
  };
  const handleCloseModal = () => {
    setIsProfileOpen(false);
  };
  const fetchMenuData = async () => {
    try {
      const res = await axInst.post(`dashboard-restriction`);
      const data = res.data;
      const updatedMenu = [...menu];
      Object.keys(data).forEach((menuName) => {
        const subMenuNames = data[menuName];
        if (!updatedMenu.some((m) => m.name === menuName)) {
          const menuItem = { ...availableMenus[menuName] };
          menuItem.subMenu = menuItem.subMenu.filter((subItem) =>
            subMenuNames.some((name) =>
              subItem.name.toLowerCase().includes(name.toLowerCase())
            )
          );
          updatedMenu.push(menuItem);
        } else {
          const menuItem = updatedMenu.find((m) => m.name === menuName);
          menuItem.subMenu = menuItem.subMenu.filter((subItem) =>
            subMenuNames.some((name) =>
              subItem.name.toLowerCase().includes(name.toLowerCase())
            )
          );
        }
      });

      setMenu([...updatedMenu, ...menuOthers]);
    } catch (error) {
      console.error("Error fetching menu data:", error);
    }
  };

  const fetchUserProfile = async () => {
    try {
      const response = await axInst.get("user-profile");
      setUserProfile(response.data); // Store user profile data
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  useEffect(() => {
    fetchMenuData();
    fetchUserProfile();
  }, []);

  const [open, setOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(null);
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  useEffect(() => {
    if (mobileOpen) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [mobileOpen]);

  const toggleSubmenu = (menuName) => {
    setSubmenuOpen((prev) => (prev === menuName ? null : menuName));
  };

  const closeSidebar = () => {
    setMobileOpen(false); // For mobile sidebar
    setOpen(false); // For desktop sidebar
  };

  const renderMenuItems = () => (
    <div className="mt-2 flex flex-col gap-3 relative">
      {!open && (
        <img
          src={Avatar}
          loading="lazy"
          alt="profile"
          className="w-10 h-10"
          onClick={handleOpenModal}
        />
      )}

      {menu.map((menuItem, i) => (
        <div
          key={i}
          className="relative group"
          onMouseEnter={() => setHoveredMenu(menuItem.name)}
          onMouseLeave={() => setHoveredMenu("")}
        >
          {menuItem.link ? (
            <Link
              to={menuItem.link}
              className={`group flex items-center text-sm gap-3.5 font-medium p-2 hover:bg-gray-800 rounded-md cursor-pointer`}
              onClick={() => {
                closeSidebar();
              }}
            >
              <div onClick={() => setOpen(!open)}>
                {React.createElement(menuItem.icon, { size: "20" })}
              </div>
              <h2
                style={{
                  transitionDelay: `${i + 3}00ms`,
                }}
                className={`whitespace-pre duration-[600] ${
                  !open && "opacity-0 translate-x-28 overflow-hidden"
                }`}
              >
                {menuItem.name}
              </h2>
              <div className="ml-auto">
                {open &&
                  menuItem.subMenu &&
                  menuItem.subMenu.length > 0 &&
                  (submenuOpen === menuItem.name ? (
                    <FaChevronDown />
                  ) : (
                    <FaChevronRight />
                  ))}
              </div>
            </Link>
          ) : (
            <Link
              to={menuItem.link || "#"}
              className={`group flex items-center text-sm gap-3.5 font-medium p-2 hover:bg-gray-800 rounded-md cursor-pointer`}
              onClick={(e) => {
                if (menuItem.subMenu && menuItem.subMenu.length > 0) {
                  e.preventDefault();
                  toggleSubmenu(menuItem.name);
                } else {
                  closeSidebar(); // Close sidebar when submenu clicked
                }
              }}
            >
              <div onClick={() => setOpen(!open)}>
                {React.createElement(menuItem.icon, { size: "20" })}
              </div>
              <h2
                style={{
                  transitionDelay: `${i + 3}00ms`,
                }}
                className={`whitespace-pre duration-500 ${
                  !open && "opacity-0 translate-x-28 overflow-hidden"
                }`}
              >
                {menuItem.name}
              </h2>
              <div className="ml-auto">
                {open &&
                  menuItem.subMenu &&
                  menuItem.subMenu.length > 0 &&
                  (submenuOpen === menuItem.name ? (
                    <FaChevronDown />
                  ) : (
                    <FaChevronRight />
                  ))}
              </div>
            </Link>
          )}
          {open && menuItem.subMenu && submenuOpen === menuItem.name && (
            <ul className="pl-4 mt-2 bg-[#2A5775]">
              {menuItem.subMenu.map((subMenu, j) => (
                <li
                  key={j}
                  className="mb-2 rounded hover:shadow hover:bg-gray-800 py-2 "
                >
                  <Link
                    to={subMenu.link}
                    className="block px-3 text-white text-sm"
                    onClick={closeSidebar} // Close sidebar when submenu item clicked
                    onMouseLeave={() => setHoveredMenu("")}
                  >
                    {subMenu.name}
                  </Link>
                </li>
              ))}
            </ul>
          )}
          {!open && hoveredMenu === menuItem.name && (
            <div
              className="absolute left-14 bg-[#2A5775] rounded-md shadow-lg z-30"
              onMouseEnter={() => setHoveredMenu(menuItem.name)}
              onMouseLeave={() => setHoveredMenu(null)}
            >
              <h2
                style={{
                  transitionDelay: `${i + 3}00ms`,
                }}
                className="font-semibold whitespace-pre text-gray-100 px-2 py-1"
              >
                {menuItem.name}
              </h2>
            </div>
          )}
        </div>
      ))}
    </div>
  );

  const SidebarProfile = ({ userProfile }) => (
    <div className="flex flex-col items-center py-4 border-b border-gray-600 cursor-pointer">
      <img
        src={Avatar}
        alt="profile"
        loading="lazy"
        onClick={handleOpenModal}
        className={`transition-all duration-500 ${
          open ? "w-20 h-20" : "w-10 h-10"
        } rounded-full`}
      />

      {userProfile ? (
        <h2 className="mt-2 text-lg font-semibold">
          {userProfile.DISPLAY_NAME}
        </h2>
      ) : (
        <h2 className="mt-2 text-lg font-semibold">Loading...</h2>
      )}
      {userProfile ? (
        <p className="text-sm text-gray-300">
          {userProfile.PRIMARY_POSITION_TYPE}
        </p>
      ) : (
        <h2 className="mt-2 text-lg font-semibold">Loading...</h2>
      )}
    </div>
  );

  return (
    <>
      <section className="hidden md:grid">
        <ProfileCardModal
          openModal={isProfileOpen}
          handleOpenModal={handleOpenModal}
          handleCloseModal={handleCloseModal}
        >
          <ProfileCard handleCloseModal={handleCloseModal} />
        </ProfileCardModal>
        <div
          className={`bg-[#2A5775] min-h-screen transition-all ease-in-out ${
            open ? "w-56" : "w-12"
          } duration-500 text-gray-100 px-2 relative`}
        >
          <div className="py-3 flex justify-end">
            {open ? (
              <RxCross2
                size={26}
                className="cursor-pointer"
                onClick={() => setOpen(!open)}
              />
            ) : (
              <HiMenuAlt3
                size={26}
                className="cursor-pointer"
                onClick={() => setOpen(!open)}
              />
            )}
          </div>
          {open && <SidebarProfile userProfile={userProfile} />}

          {renderMenuItems()}
        </div>
      </section>

      {/* Mobile Sidebar */}
      {mobileOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-10 md:hidden">
          <div className="bg-[#2A5775] min-h-screen w-56 text-gray-100 px-4 fixed z-20">
            <div className="py-3 flex justify-end">
              <RxCross2
                size={26}
                className="cursor-pointer"
                onClick={() => setMobileOpen(false)}
              />
            </div>
            {renderMenuItems()}
          </div>
          <div
            className="w-full h-full"
            onClick={() => setMobileOpen(false)}
          ></div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
